import { HeaderValues } from 'src/Utils/csv/csv.constants'

export interface ImportFrameworkRequirementsCSVRow {
  name: string
  description: string
  group: string
  groupDescription: string
  controlMappings: string[]
}

export const FRAMEWORK_REQUIREMENT_CSV_HEADERS: HeaderValues[] = [
  { input: 'name', output: 'name' },
  { input: 'description', output: 'description', optional: true },
  { input: 'group', output: 'group', optional: true },
  {
    input: 'group_description',
    output: 'groupDescription',
    optional: true,
  },
  { input: 'control_mappings', output: 'controlMappings', optional: true },
]

export const FRAMEWORK_REQUIREMENT_CSV_TEMPLATE = [
  {
    name: 'Access reviews',
    description: 'Periodic access reviews are performed.',
    group: 'Access control',
    group_description: 'Controls for logical and physical access.',
    control_mappings: '',
  },
  {
    name: 'Encryption in transit',
    description: 'Data is encrypted using TLS.',
    group: 'Security',
    group_description: '',
    control_mappings: '',
  },
]
